import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { TrustBankList } from "../../../../components/DirectDeposit/TrustBank/TrustBankList";

export interface ITrustBankListPage { }

export const TrustBankListPage: FC<ITrustBankListPage> = (
	props: ITrustBankListPage
) => {
	return (
		<AuthenticatedLayout
			pageTitle="TrustBank List"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName="/TrustBankDashboard"
			breadcrumbLinks={[]}
			mainContents={<TrustBankList />}
		/>
	);
};
